import axios from 'axios';
const instance = axios.create({ baseURL: 'https://api.fapshi.com' });
export default instance;
